import React, { Component } from "react";
import i18n from "i18next";
import PropTypes from "prop-types";
import AppModal from "../common/modal/AppModal";

// Shown when the user tries to leave via the browser Back button while
// there are unsaved changes (see useUnsavedChangesGuard). Mirrors
// ExitModal's layout/button styling for consistency with the app's other
// "leaving the editor" dialog.
export default class UnsavedChangesGuardModal extends Component {
  render() {
    const { show, saving, error, onStay, onLeaveWithoutSaving, onSaveAndLeave } = this.props;

    const footer = (
      <div className="app-modal__footer">
        <button
          type="button"
          className="app-modal__btn app-modal__btn--ghost"
          onClick={onStay}
          disabled={saving}
        >
          {i18n.t("unsavedChangesGuard.stay", { defaultValue: "Stay" })}
        </button>
        <button
          type="button"
          className="app-modal__btn app-modal__btn--ghost"
          onClick={onLeaveWithoutSaving}
          disabled={saving}
        >
          {i18n.t("unsavedChangesGuard.leaveWithoutSaving", {
            defaultValue: "Leave without saving",
          })}
        </button>
        <button
          type="button"
          className="app-modal__btn app-modal__btn--primary"
          onClick={onSaveAndLeave}
          disabled={saving}
        >
          {saving
            ? i18n.t("unsavedChangesGuard.saving", { defaultValue: "Saving…" })
            : i18n.t("unsavedChangesGuard.saveAndLeave", { defaultValue: "Save and leave" })}
        </button>
      </div>
    );

    return (
      <AppModal
        show={!!show}
        onClose={onStay}
        title={i18n.t("unsavedChangesGuard.title", { defaultValue: "Unsaved changes" })}
        size="md"
        closeButton={false}
        showSceneToggle={false}
        footer={footer}
      >
        {i18n.t("unsavedChangesGuard.body", {
          defaultValue: "You have unsaved changes. What would you like to do before you leave?",
        })}
        {error && <div style={{ color: "#dc3545", marginTop: 12, fontSize: 13 }}>{error}</div>}
      </AppModal>
    );
  }
}

UnsavedChangesGuardModal.propTypes = {
  show: PropTypes.bool,
  saving: PropTypes.bool,
  error: PropTypes.string,
  onStay: PropTypes.func.isRequired,
  onLeaveWithoutSaving: PropTypes.func.isRequired,
  onSaveAndLeave: PropTypes.func.isRequired,
};
